import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Badge } from 'react-bootstrap'
import { toCurrency } from '../../../../../../../utils/helpers/index.js'
import InputNumericWiz from '../../../../../../../common/inputs/wizard/InputNumericWiz.jsx'
import SelectWiz from '../../../../../../../common/inputs/wizard/SelectWiz.jsx'
import { optionsOcenaRealizacji } from '../../../../../../../utils/options.js'

export const getEvaluationVariant = (ocena) => {
    const option = optionsOcenaRealizacji.find((opt) => opt.value === ocena)
    return option ? option.variant : 'secondary'
}

export const TaskItemCard = ({ task, row, setRow, idx, wiz }) => {
    const budgetFieldKey = `realizacja_wydatkowanie_narastajaco`
    const ratingFieldKey = `realizacja_ocena`

    const currentOcena = (row?.realizacja_ocena ?? task.ocena) || 'Nie rozpoczęty'

    const plan = parseFloat(task.budzet_planowany || 0)
    const wydatek = parseFloat(
        (row?.realizacja_wydatkowanie_narastajaco ?? task.wydatkowanie_narastajaco) || 0
    )
    const percent = plan > 0 ? (wydatek / plan) * 100 : 0
    const percentValue = Number.isFinite(percent) ? percent.toFixed(2) : ''
    const normalizedRowPercent = (() => {
        const rawValue = row?.realizacja_procent_wydatkowania
        if (rawValue === null || rawValue === undefined || rawValue === '') {
            return ''
        }
        const parsed = parseFloat(rawValue)
        if (!Number.isFinite(parsed)) {
            return String(rawValue)
        }
        return parsed.toFixed(2)
    })()

    const dateText = task.isMilestone
        ? task.koniec && task.koniec !== '-'
            ? task.koniec
            : task.start
        : `${task.start} — ${task.koniec}`

    const percentVariant = percent > 100 ? 'danger' : 'success'
    const borderVariant = getEvaluationVariant(currentOcena)

    const colLayout = task.isMilestone
        ? { name: 8, date: 2, rating: 2 }
        : { name: 4, date: 1, budgetPlan: 2, budgetInput: 2, percent: 1, rating: 2 }

    useEffect(() => {
        if (!row?.realizacja_ocena) {
            setRow(ratingFieldKey, 'Nie rozpoczęty')
        }
    }, [row?.realizacja_ocena])

    useEffect(() => {
        if (normalizedRowPercent !== percentValue) {
            setRow('realizacja_procent_wydatkowania', percentValue)
        }
    }, [normalizedRowPercent, percentValue])

    return (
        <Card
            className={`mb-3 border-${borderVariant}`} style={{ borderLeftWidth: '6px' }}
        >
            <Card.Body className="py-3">
                <Row className="align-items-stretch">
                    <Col
                        lg={colLayout.name}
                        xs={12}
                        className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center"
                    >
                        <div className="d-flex align-items-center mb-2">
                            <h6 className="mb-0 fw-bold me-2">
                                {task.nazwa}
                            </h6>
                            {task.isMilestone && <Badge bg="warning">KM</Badge>}
                        </div>
                    </Col>
                    <Col
                        lg={colLayout.date}
                        xs={12}
                        className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center"
                    >
                        <div className="text-muted small">{dateText}</div>
                    </Col>

                    {!task.isMilestone && (
                        <Col
                            lg={colLayout.budgetPlan}
                            xs={12}
                            className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center"
                        >
                            <div className="small">
                                <span>
                                    Budżet planowany [ZŁ]:{' '}
                                    <strong>{toCurrency(plan)}</strong>
                                </span>
                            </div>
                        </Col>
                    )}

                    {!task.isMilestone && (
                        <Col
                            lg={colLayout.budgetInput}
                            xs={12}
                            className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center"
                        >
                            <InputNumericWiz
                                row={row}
                                setRow={setRow}
                                idx={idx}
                                wiz={wiz}
                                keyName={budgetFieldKey}
                                decimal={2}
                                max={99999999999999.99}
                                className="text-end"
                            />
                        </Col>
                    )}

                    {!task.isMilestone && (
                        <Col
                            lg={colLayout.percent}
                            xs={12}
                            className="mb-3 mb-md-0 border-end px-3 d-flex flex-column justify-content-center"
                        >
                            <small>% Wydatkowania</small>
                            <div className={`fw-bold fs-6 text-${percentVariant}`}>
                                {Number.isFinite(percent)
                                    ? percentValue + '%'
                                    : '-'}
                            </div>
                        </Col>
                    )}

                    <Col lg={colLayout.rating} xs={12}>
                        <SelectWiz
                            row={row}
                            setRow={setRow}
                            idx={idx}
                            wiz={wiz}
                            keyName={ratingFieldKey}
                            options={optionsOcenaRealizacji}
                            placeholder="Wybierz ocenę..."
                            value={currentOcena}
                            noLabel={true}
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

TaskItemCard.propTypes = {
    task: PropTypes.object.isRequired,
    row: PropTypes.object,
    setRow: PropTypes.func.isRequired,
    idx: PropTypes.number.isRequired,
    wiz: PropTypes.any,
}

export default TaskItemCard
